import type { SidebarConfig } from './types';

/**
 * Utility function to get the URL for a sidebar app ID using the provided config.
 * This is useful for components that need to generate URLs but don't have access
 * to the full sidebar hook.
 *
 * @param config - The sidebar configuration containing the getUrl function
 * @param appId - The app ID to get the URL for
 * @returns The URL path for the given app ID
 */
export const getUrlForSidebarAppId = (config: SidebarConfig, appId: string): string => {
  const context = config.getContext();
  return config.getUrl(appId, context);
};
